import React, { useState } from "react";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import ConfirmationModal from "../../../components/common/ConfirmModal";
import "./VpaRefund.css";
import { addVpaTransfer } from "../../../config/LiveApi";

const generateRandomMobile = () => {
  const prefix = Math.floor(Math.random() * 5) + 6;
  const rest = Math.floor(100000000 + Math.random() * 900000000);
  return prefix + rest.toString();
};

const generateUUID = () => {
  return crypto.randomUUID
    ? crypto.randomUUID()
    : ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, (c) =>
        (
          c ^
          (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (c / 4)))
        ).toString(16)
      );
};

const changeTxnStatusByUrl = async (token, payload, url) => {
  const res = await fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(payload),
  });

  if (!res.ok) {
    throw new Error(`API call failed with status ${res.status}`);
  }

  const text = await res.text();
  try {
    return text ? JSON.parse(text) : { message: "No response body" };
  } catch (err) {
    throw new Error("Invalid JSON response");
  }
};

const defaultTxn = () => ({
  mode: "UPI",
  beneName: "test",
  beneMobile: generateRandomMobile(),
  orderId: generateUUID(),
  vpa: "",
  amount: "",
  remark: "",
  utr: "",
  provider: "Vexora",
  response: "",
});

const AddForm = () => {
  const token = useSelector((store) => store.userReducer.token);
  const [loading, setLoading] = useState(false);
  const [isConfirmModal, setIsConfirmModal] = useState(false);
  const [data, setData] = useState([defaultTxn()]);

  // ✅ UPI WITHDRAWAL STATES
  const [upiAmount, setUpiAmount] = useState("");
  const [upiAddress, setUpiAddress] = useState("");
  const [upiRemark, setUpiRemark] = useState("");
  const [upiLoading, setUpiLoading] = useState(false);
  const [upiResponse, setUpiResponse] = useState("");

    // ✅ IMPS WITHDRAWAL STATES
  const [impsAmount, setImpsAmount] = useState("");
const [accountNumber, setAccountNumber] = useState("");
const [ifscCode, setIfscCode] = useState("");
const [impsRemark, setImpsRemark] = useState("");
const [impsBeneName, setimpsBeneName] = useState("");
const [impsLoading, setImpsLoading] = useState(false);
const [impsResponse, setImpsResponse] = useState("");
  const selectProviderLink = {
    Vexora: "https://admin.shoppingora.com/backend/cash-cado/v1/payout/upi",
    GetExpo: "https://admin.getxpo.com/backend/cash-cado/v1/payout/upi",
  };

  const handleAddOrder = (index) => {
    const newData = [...data];
    const { vpa, amount } = newData[index];
    if (vpa.trim() && amount.trim()) {
      newData.push(defaultTxn());
      setData(newData);
    } else {
      toast.warning("Please fill VPA and Amount before adding a new row");
    }
  };

  const handleRemoveOrder = (index) => {
    const newData = data.filter((_, i) => i !== index);
    setData(newData.length > 0 ? newData : [defaultTxn()]);
  };

  const handleInputChange = (index, field, value) => {
    const newData = [...data];
    newData[index][field] = value;
    newData[index].response = "";
    setData(newData);
  };

  const openConfirmation = () => {
    return new Promise((resolve) => {
      setIsConfirmModal(() => ({
        isOpen: true,
        onResolve: resolve,
      }));
    });
  };

  const handleSubmit = async () => {
    setLoading(true);
    const userConfirmed = await openConfirmation();
    if (!userConfirmed) {
      setLoading(false);
      return;
    }

    const updatedData = [...data];

    for (let i = 0; i < updatedData.length; i++) {
      const txn = updatedData[i];
      const { vpa, amount, provider, utr, remark } = txn;

      if (vpa && amount && provider) {
        const url = selectProviderLink[provider];
        if (!url) {
          updatedData[i].response = "Invalid provider selected.";
          continue;
        }

        try {
          const res = await changeTxnStatusByUrl(token, txn, url);
          updatedData[i].response = res;

          try {
            const payload = { vpa, amount, utr, remark, apiResponse: res };
            await addVpaTransfer(payload);
          } catch (error) {
            console.log("error from add data in vpa", error);
          }
        } catch (err) {
          updatedData[i].response = `Error: ${err.message}`;
        }
      } else {
        updatedData[i].response = "Missing VPA or Amount";
      }
    }

    setData(updatedData);
    toast.success("Transactions processed");
    setLoading(false);
  };

  // ✅ NEW UPI SUBMIT (No provider, no actions)
  const handleUpiSubmit = async () => {
    if (!upiAmount || !upiAddress) {
      toast.error("UPI Address and Amount are required");
      return;
    }

    setUpiLoading(true);
    setUpiResponse("");

    const payload = {
      amount: upiAmount,
      mode: "UPI",
      beneName: "Test",
      upiAddress: upiAddress,
      beneEmail: "test@gmail.com",
      beneMobile: "+919999999999",
      remark: upiRemark || "UPI Withdrawal",
    };

    try {
      const res = await fetch(
        "https://admin.kwicpe.com/api/v1/withdrawal/upi/initiate",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "api-key": "c672e496899f61488e90.aLHGzBYG9hWMuu39ZnQNwIJsliUtqCBwv2Si",
          },
          body: JSON.stringify(payload),
        }
      );

      const data = await res.json();
      setUpiResponse(data);
      toast.success("UPI Withdrawal Initiated");
    } catch (err) {
      setUpiResponse(err.message);
      toast.error("Request Failed");
    }

    setUpiLoading(false);
  };
const handleImpsSubmit = async () => {
  if (!accountNumber || !ifscCode || !impsAmount) {
    toast.error("Account Number, IFSC and Amount are required");
    return;
  }

  // ✅ Ask confirmation first
  const userConfirmed = await openConfirmation();
  if (!userConfirmed) return;

  setImpsLoading(true);
  setImpsResponse("");

  const payload = {
    accountType: "savings",
    amount: impsAmount,
    mode: "IMPS",
    ifscCode: ifscCode,
    accountNo: accountNumber,
    branchname: "SBI",
    beneName: impsBeneName || "Test",
    beneEmail: "test@gmail.com",
    beneMobile: "+919876546789",
    beneBankName: "SBI BANK",
    remark: impsRemark || "IMPS Withdrawal",
  };

  try {
    const res = await fetch(
      "https://admin.kwicpe.com/api/v1/payout/initiate",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "api-key":
            "c672e496899f61488e90.aLHGzBYG9hWMuu39ZnQNwIJsliUtqCBwv2Si",
        },
        body: JSON.stringify(payload),
      }
    );

    const data = await res.json();
    setImpsResponse(data);
    toast.success("IMPS Withdrawal Initiated");
  } catch (err) {
    setImpsResponse(err.message);
    toast.error("IMPS Request Failed");
  }

  setImpsLoading(false);
};
  return (
    <>
      <h1 className="refund-head">Refund Amount</h1>
      <div className="refund-container">
        <table className="refund-table">
          <thead>
            <tr>
              <th>VPA</th>
              <th>Amount</th>
              <th>UTR</th>
              <th>Remark</th>
              <th>Select Provider</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {data.map((txn, index) => (
              <React.Fragment key={index}>
                <tr>
                  <td><input className="refund-input" value={txn.vpa} onChange={(e) => handleInputChange(index, "vpa", e.target.value)} /></td>
                  <td><input className="refund-input" value={txn.amount} onChange={(e) => handleInputChange(index, "amount", e.target.value)} /></td>
                  <td><input className="refund-input" value={txn.utr} onChange={(e) => handleInputChange(index, "utr", e.target.value)} /></td>
                  <td><input className="refund-input" value={txn.remark} onChange={(e) => handleInputChange(index, "remark", e.target.value)} /></td>
                  <td>
                    <select className="change-status-select" value={txn.provider} onChange={(e) => handleInputChange(index, "provider", e.target.value)}>
                      <option value="Vexora">Vexora</option>
                      <option value="GetExpo">GetExpo</option>
                    </select>
                  </td>
                  <td>
                    <button className="action-btn" onClick={() => handleAddOrder(index)}>✔</button>
                    <button className="action-btn" onClick={() => handleRemoveOrder(index)}>✘</button>
                  </td>
                </tr>

                {txn.response && (
                  <tr>
                    <td colSpan="6">
                      <div className="response-box"><strong>Response:</strong>
                        <code>{typeof txn.response === "string" ? txn.response : JSON.stringify(txn.response)}</code>
                      </div>
                    </td>
                  </tr>
                )}
              </React.Fragment>
            ))}
          </tbody>
        </table>

        <button className="submit-btn" onClick={handleSubmit} disabled={loading}>
          {loading ? <div className="button-loader"></div> : "Submit"}
        </button>
      </div>

      {/* ✅ UPDATED UPI SECTION (TABLE STYLE, NO PROVIDER, NO ACTIONS) */}
      <h2 className="refund-head" style={{ marginTop: "40px" }}>UPI Withdrawal</h2>

      <div className="refund-container">
        <table className="refund-table">
          <thead>
            <tr>
              <th>UPI Address</th>
              <th>Amount</th>
              <th>Remark</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td><input className="refund-input" value={upiAddress} onChange={(e) => setUpiAddress(e.target.value)} /></td>
              <td><input className="refund-input" value={upiAmount} onChange={(e) => setUpiAmount(e.target.value)} /></td>
              <td><input className="refund-input" value={upiRemark} onChange={(e) => setUpiRemark(e.target.value)} /></td>
            </tr>

            {upiResponse && (
              <tr>
                <td colSpan="3">
                  <div className="response-box">
                    <strong>Response:</strong>
                    <code>{JSON.stringify(upiResponse, null, 2)}</code>
                    <button
                      className="action-btn"
                      style={{ marginTop: "10px" }}
                      onClick={() => {
                        navigator.clipboard.writeText(JSON.stringify(upiResponse, null, 2));
                        alert("✅ Response copied!");
                      }}
                    >
                      Copy
                    </button>
                  </div>
                </td>
              </tr>
            )}
          </tbody>
        </table>

        <button className="submit-btn" onClick={handleUpiSubmit} disabled={upiLoading}>
          {upiLoading ? <div className="button-loader"></div> : "Submit Withdrawal"}
        </button>
      </div>
      {/* ✅ IMPS (TABLE STYLE, NO PROVIDER, NO ACTIONS) */}
      {/* ✅ IMPS (TABLE STYLE) */}
<h2 className="refund-head" style={{ marginTop: "40px" }}>
  IMPS Withdrawal
</h2>

<div className="refund-container">
  <table className="refund-table">
    <thead>
      <tr>
        <th>Account Number</th>
        <th>IFSC Code</th>
        <th>Amount</th>
        <th>Name</th>
        <th>Remark</th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td>
          <input
            className="refund-input"
            value={accountNumber}
            onChange={(e) => setAccountNumber(e.target.value)}
          />
        </td>
        <td>
          <input
            className="refund-input"
            value={ifscCode}
            onChange={(e) => setIfscCode(e.target.value)}
          />
        </td>
        <td>
          <input
            className="refund-input"
            value={impsAmount}
            onChange={(e) => setImpsAmount(e.target.value)}
          />
        </td>
        <td>
          <input
            className="refund-input"
            value={impsBeneName}
            onChange={(e) => setimpsBeneName(e.target.value)}
          />
        </td>
        <td>
          <input
            className="refund-input"
            value={impsRemark}
            onChange={(e) => setImpsRemark(e.target.value)}
          />
        </td>
      </tr>

      {impsResponse && (
        <tr>
          <td colSpan="4">
            <div className="response-box">
              <strong>Response:</strong>
              <code>{JSON.stringify(impsResponse, null, 2)}</code>
              <button
                className="action-btn"
                style={{ marginTop: "10px" }}
                onClick={() => {
                  navigator.clipboard.writeText(
                    JSON.stringify(impsResponse, null, 2)
                  );
                  alert("✅ Response copied!");
                }}
              >
                Copy
              </button>
            </div>
          </td>
        </tr>
      )}
    </tbody>
  </table>

  <button
    className="submit-btn"
    onClick={handleImpsSubmit}
    disabled={impsLoading}
  >
    {impsLoading ? (
      <div className="button-loader"></div>
    ) : (
      "Submit IMPS Withdrawal"
    )}
  </button>
</div>

      {isConfirmModal && (
        <ConfirmationModal
          onResolve={(decision) => {
            isConfirmModal.onResolve(decision);
            setIsConfirmModal(false);
          }}
        />
      )}
    </>
  );
};

export default AddForm;
